// extracted by mini-css-extract-plugin
export default {"notify":"notify-y0URZO","icon":"icon-E5ctHW","overlay":"overlay-MIs7lO"};